module.exports = __webpack_public_path__ + "static/media/wave.fbe4bed8.svg";